import { ResourcesConfig } from 'aws-amplify';

const config: ResourcesConfig = {
  Auth: {
    Cognito: {
      allowGuestAccess: true,
      userPoolId: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID ?? '',
      userPoolClientId: process.env.NEXT_PUBLIC_COGNITO_APP_CLIENT_ID ?? '',
      identityPoolId: process.env.NEXT_PUBLIC_COGNITO_IDENTITY_POOL_ID ?? '',
      loginWith: {
        oauth: {
          domain: process.env.NEXT_PUBLIC_COGNITO_DOMAIN ?? '',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [
            process.env.NEXT_PUBLIC_COGNITO_REDIRECT_SIGN_IN ?? '',
            process.env.NEXT_PUBLIC_COGNITO_REDIRECT_SIGN_IN_DOMAIN ?? ''
          ],
          redirectSignOut: [
            process.env.NEXT_PUBLIC_COGNITO_REDIRECT_SIGN_OUT ?? '',
            process.env.NEXT_PUBLIC_COGNITO_REDIRECT_SIGN_OUT_DOMAIN ?? ''
          ],
          responseType: 'code',
        },
      }
    }
  }
}

export default config;